// Datos de la empresa emisora: es LO QUE SALE IMPRESO en el encabezado de
// cada remito. Antes solo se podia cambiar por SQL — de ahi esta pantalla.
// Solo admin.

import { api } from "../api";
import { marcaEmpresa } from "../remito";
import type { Empresa } from "../../lib/types";

function esc(s: unknown): string {
  return String(s ?? "").replace(/[&<>"]/g, (c) =>
    ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;" })[c] as string,
  );
}

export async function renderEmpresa(contenedor: HTMLElement): Promise<void> {
  contenedor.innerHTML = `
    <div class="mb-4">
      <h1 class="titulo-pagina">Empresa</h1>
      <p class="subtitulo">Estos datos salen impresos en el encabezado de cada remito.</p>
    </div>
    <div id="cuerpo"><div class="tarjeta text-center text-masa-400">Cargando...</div></div>`;

  const cuerpo = contenedor.querySelector("#cuerpo") as HTMLElement;

  let empresas: Empresa[] = [];
  try {
    empresas = await api.get<Empresa[]>("/api/empresas");
  } catch (e) {
    cuerpo.innerHTML = `<div class="tarjeta text-red-700">${esc(
      e instanceof Error ? e.message : "Error",
    )}</div>`;
    return;
  }
  if (empresas.length === 0) {
    cuerpo.innerHTML = `<div class="tarjeta text-center text-masa-400">No hay ninguna empresa cargada.</div>`;
    return;
  }

  const e = empresas[0];
  const campo = (id: string, lbl: string, valor: string | null, ph = "") =>
    `<label><span class="etiqueta">${lbl}</span>
      <input id="${id}" class="campo" value="${esc(valor ?? "")}" placeholder="${esc(ph)}" /></label>`;

  cuerpo.innerHTML = `
    <form id="f" class="tarjeta mb-4 grid grid-cols-1 gap-3 sm:grid-cols-2">
      ${campo("nombre", "Nombre", e.nombre, "Confitería Piedra y Sol")}
      ${campo("telefono", "Teléfono", e.telefono, "2209 3900")}
      ${campo("direccion", "Dirección", e.direccion, "José Nasazzi 1022")}
      ${campo("ciudad", "Ciudad", e.ciudad, "Montevideo, Uruguay")}
      ${campo("email", "Email (opcional)", e.email)}
      <div class="flex items-center gap-3 sm:col-span-2">
        <button class="btn-primario">Guardar</button>
        <span id="msg" class="text-sm"></span>
      </div>
    </form>

    <div class="tarjeta">
      <h2 class="etiqueta">Así va a salir el remito</h2>
      <div id="preview" class="rounded-xl border border-crema-200 bg-white p-4 text-black"></div>
    </div>`;

  const msg = cuerpo.querySelector("#msg") as HTMLElement;
  const preview = cuerpo.querySelector("#preview") as HTMLElement;
  const val = (id: string) => (cuerpo.querySelector("#" + id) as HTMLInputElement).value.trim();

  // La vista previa se arma con las MISMAS piezas que el remito real
  // (marcaEmpresa + la linea "Emite"), asi lo que se ve es lo que se imprime.
  function pintarPreview(): void {
    const emite = [val("nombre"), val("direccion"), val("ciudad"), val("telefono") ? `Tel. ${val("telefono")}` : ""]
      .filter(Boolean)
      .map(esc)
      .join(" · ");
    preview.innerHTML = `
      ${marcaEmpresa()}
      <div class="mt-1 text-xl font-bold">Remito</div>
      <div class="border-b border-black/20 pb-1 text-xs"><b>Emite:</b> ${emite}</div>`;
  }
  pintarPreview();
  cuerpo.querySelector("#f")?.addEventListener("input", pintarPreview);

  (cuerpo.querySelector("#f") as HTMLFormElement).addEventListener("submit", async (ev) => {
    ev.preventDefault();
    msg.textContent = "";
    msg.className = "text-sm";
    if (!val("nombre")) {
      msg.textContent = "El nombre es obligatorio";
      msg.className = "text-sm text-red-600";
      return;
    }
    try {
      await api.put(`/api/empresas/${e.id}`, {
        nombre: val("nombre"),
        direccion: val("direccion") || null,
        ciudad: val("ciudad") || null,
        telefono: val("telefono") || null,
        email: val("email") || null,
      });
      msg.textContent = "Guardado. Los próximos remitos ya salen con estos datos.";
      msg.className = "text-sm text-green-700";
    } catch (err) {
      msg.textContent = err instanceof Error ? err.message : "Error";
      msg.className = "text-sm text-red-600";
    }
  });
}
